import "./section.css"

import { useState } from "react";

export default function ParametrosCierre() {

  const [politicas, setPoliticas] = useState({
    restringirMultiplesPeriodos: false,
    permitirReapertura: false,
    permitirMovimientosPosteriores: false,
    horaCierreAutomatico: "",
    requiereConciliacionInventario: false,
    requiereCierreCaja: false,
  });

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    setPoliticas(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleGuardar = () => {
    console.log("Políticas guardadas:", politicas);
    // Aquí iría tu llamada al backend
  };

  return (
    <div className="politicas-cierre-container">

      <h3>Políticas de Cierre</h3>

      {/* REGLAS GENERALES */}
      <section className="bloque-config">
        <h4>Reglas Generales</h4>
            <label>
          <input
            type="checkbox"
            name="restringirMultiplesPeriodos"
            checked={politicas.restringirMultiplesPeriodos}
            onChange={handleChange}
          />
          Restringir múltiples períodos abiertos
        </label>

        <label>
          <input
            type="checkbox"
            name="permitirReapertura"
            checked={politicas.permitirReapertura}
            onChange={handleChange}
          />
          Permitir reapertura de período
        </label>

        <label>
          <input
            type="checkbox"
            name="permitirMovimientosPosteriores"
            checked={politicas.permitirMovimientosPosteriores}
            onChange={handleChange}
          />
          Permitir movimientos posteriores al cierre
        </label>
      </section>

      {/* CIERRE AUTOMÁTICO */}
      <section className="bloque-config">
        <h4>Cierre Automático</h4>

        <label>Hora de cierre</label>
        <input
          type="time"
          name="horaCierreAutomatico"
          value={politicas.horaCierreAutomatico}
          onChange={handleChange}
        />
      </section>

      {/* VALIDACIONES */}
      <section className="bloque-config">
        <h4>Validaciones Obligatorias</h4>

        <label>
          <input
            type="checkbox"
            name="requiereConciliacionInventario"
            checked={politicas.requiereConciliacionInventario}
            onChange={handleChange}
          />
          Requiere conciliación de inventario
        </label>

        <label>
          <input
            type="checkbox"
            name="requiereCierreCaja"
            checked={politicas.requiereCierreCaja}
            onChange={handleChange}
          />
          Requiere cierre de caja
        </label>
      </section>

      <button onClick={handleGuardar}>
        Guardar Políticas
      </button>

    </div>
  );
}